import React, { useState } from 'react';
import { Tabs } from 'antd';
import OferteTab from './components/OferteTab';
import ClientiTab from './components/ClientiTab';

const { TabPane } = Tabs;

function Oferte() {
  const [activeTab, setActiveTab] = useState('oferte');

  return (
    <div className="p-6">
    
      <Tabs 
        activeKey={activeTab} 
        onChange={setActiveTab}
        className="w-full"
        size="large"
      >
        <TabPane tab="Oferte" key="oferte">
          <OferteTab />
        </TabPane>
        <TabPane tab="Clienți" key="clienti">
          <ClientiTab />
        </TabPane>
      </Tabs>
    </div>
  );
}

export default Oferte;